'use client';

import { ReactNode } from 'react';
import styles from './ToggleButton.module.css';

interface ToggleButtonProps {
  pressed: boolean;
  onPress: () => void;
  children: ReactNode;
  className?: string;
}

export function ToggleButton({ pressed, onPress, children, className = '' }: ToggleButtonProps): React.JSX.Element {
  return (
    <button
      type="button"
      aria-pressed={pressed}
      onClick={onPress}
      className={`${styles.toggle} ${pressed ? styles.pressed : ''} ${className}`}
    >
      {children}
    </button>
  );
}
